import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { WorkOrderTypes } from '../constants/work-order-types';
import { WorkOrderStatus } from '../constants/work-order-status';
import { formatDate } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class WorkOrderDashboardModalService {
  public showStatusModal: boolean = false;
  public showDeadlineDateModal: boolean = false;
  public showDescriptionModal: boolean = false;
  public showCommentModal: boolean = false;
  public showModal: boolean = false;

  public work_order_id: string = '';
  public status: string = '';
  public deadlineDate: string = '';
  public description: string = '';
  public comment: string = '';
  private isStatusChange: boolean = false;
  private isDeadlineChange: boolean = false;
  private isCommentChange: boolean = false;
  private isDescriptionchange: boolean = false;
  public statusArray: any[] = [...WorkOrderStatus];
  public workOrderTypes: any [] = [...WorkOrderTypes];

  public userSub: string = '';

  selectedWorkOrder: any;
  // Work order arrays
  public workOrderArray: any[] = [];
  public originalWorkOrderArray: any[] = [];

  constructor(private http: HttpClient) { }

  // Function called from the work order list to open the status change modal
  changeStatus(workOrder: any){
    this.selectedWorkOrder = workOrder;

    this.work_order_id = this.selectedWorkOrder.work_order_id;
    this.status = this.selectedWorkOrder.status;
    this.showModal = true;
    this.showStatusModal = true;
    this.isStatusChange = true;
  }

  // Function called from the work order list to open the deadline date modal
  changeDeadline(workOrder: any){
    this.selectedWorkOrder = workOrder;
    
    this.work_order_id = this.selectedWorkOrder.work_order_id;
    this.deadlineDate = this.selectedWorkOrder.work_order_deadline;
    this.showModal = true;
    this.showDeadlineDateModal = true;
    this.isDeadlineChange = true;
  }

  // function called by the work order list to open the description modal
  changeDescription(workOrder: any){
    this.selectedWorkOrder = workOrder;

    this.work_order_id = this.selectedWorkOrder.work_order_id;
    this.description = this.selectedWorkOrder.description;
    this.showModal = true;
    this.showDescriptionModal = true;
    this.isDescriptionchange = true;
  }

  // function called by the work order list to open the comments modal
  addComment(workOrder: any, userSub: string){
    this.selectedWorkOrder = workOrder

    this.work_order_id = this.selectedWorkOrder.work_order_id;
    this.comment = this.selectedWorkOrder.comment;
    this.userSub = userSub;
    this.showModal = true;
    this.showCommentModal = true;
    this.isCommentChange = true;
  }

  // Function called when user change the status of the work order
  statusChange(status: string){
    const statusLabel = this.statusArray.find(s => s.value === status)?.label ?? ''
    this.status = statusLabel;
  }

  // Function called when user chaneg the date on the modal
  deadlineDateChange(selectedDate: string){
    const convertedDate = new Date(selectedDate);
    const utcTimeStamp = convertedDate.getTime();
    this.deadlineDate = utcTimeStamp.toString();
  }

  // Function called when user change the description on modal
  descriptionChange(selectedDescription: string){
    this.description = selectedDescription;
  }

  // Function called when user change the comments on the modal
  commentChange(comment: string){
    this.comment = comment;
  }

  // Function called when user submit the change made
  async submitChange(){
    if(this.work_order_id !== ''){
      try{
        // Call the function that made the call to lambda function and wait for is response
        await firstValueFrom(this.updateWorkOrderLambda())
        this.setNewValues();
        this.close();
      }
      catch(e){
        console.error(e)
      }
    }
  }

  // Function used when work order update is done to change the vlue on work order list
  setNewValues(){
    if(this.selectedWorkOrder){
      // Switch between different bool variable to know witch part of the work order the user have change
      switch(true){
        case this.isStatusChange:
          this.selectedWorkOrder.status = this.status;
          break;
  
        case this.isDeadlineChange:
          this.selectedWorkOrder.work_order_deadline = this.deadlineDate;
          break;
  
        case this.isDescriptionchange:
          this.selectedWorkOrder.description = this.description;
          break;
  
        case this.isCommentChange:
          this.selectedWorkOrder.comment = this.comment;
          break;
      }
    }
  }

  updateWorkOrderLambda(){
    // Get the value of the status constant by comparing labels
    const statusValue = this.statusArray.find(s => s.label === this.status)?.value ?? '';
    // Get today's date for saving in DB
    const today: Date = new Date();
    const todayDate: string = today.getTime().toString();

    // Define the HTTP headers with content type
    const headers = new HttpHeaders({
      'Content-Type':  'application/json' // Adjust content type as needed
    });
    // Will call the lambda function in updateBinModel url whit the passed data then return a response
    return this.http.post(environment.api.stage + environment.api.route.updateWorkOrder, {
      // Doubled coats things are used into lambda function as data and used for the SQL's calls that those functions does
        "work_order_id": this.work_order_id,
        "user_sub": this.userSub,
        "status": statusValue,
        "deadlineDate": this.deadlineDate,
        "description": this.description,
        "comment": this.comment,
        "date": todayDate,
      }, { headers: headers }
    );
  }

  // Function that close all from modal
  close(){
    // Set all variable for showing modal at false to hide the modal
    this.showModal = false;
    this.showDeadlineDateModal = false;
    this.showDescriptionModal = false;
    this.showStatusModal = false;
    this.showCommentModal =false;

    // Set all his variables to default to avoid bad entry
    this.selectedWorkOrder = null;
    this.work_order_id = '';
    this.status = '';
    this.description = '';
    this.comment = '';
    this.deadlineDate = '';

    // Set to false all other variables
    this.isCommentChange = false;
    this.isDeadlineChange = false;
    this.isDescriptionchange = false;
    this.isStatusChange = false;
  }
}
